import { mapDatatype } from "../../../shared/definitions/datatype-mapping";
import { IDataType } from "../../../shared/definitions/datatypes";
import { createUUID, IObject } from "../../../shared/utils/utils";

export interface IText {
  type: "text";
}

export interface IColumn {
  key: string;
  displayName: string;
  dataType: IDataType | IText;
  sortable?: boolean;
}

export function transformToBackendDatamodelReport(data: any) { // eslint-disable-line
  return {
    report_id: data.report_id,
    report_name: data.report_name,
    columns: data.columns.map((col: IObject) => ({
      agg: col.agg,
      aggregator_title: col.aggregator_title,
      field: col.field,
      agg_datatype: col.agg_datatype
    })),
    datamodel_type: data.datamodel_type,
    datamodel_id: data.datamodel_id,
    alertcase_id: data.alertcase_id,
    group_by: data.group_by,
    group_by_datatype: data.group_by_datatype,
    query_filters: data.query_filters.map((filter: IObject) => ({
      field: filter.field,
      op: filter.op,
      value: filter.value,
      field_type: filter.field_type
    }))
  };
}

export function transformFromBackendDatamodelReport(backendType: any) { // eslint-disable-line 
  let columns: IColumn[] = [];
  if (backendType.columns) {
    columns = backendType.columns.map((col: IObject) => ({
      key: col.key,
      displayName: col.title,
      dataType: mapDatatype(col.datatype),
      sortable: true,
    }));
  }

  const result = {
    columns,
    rowData: backendType.rows?.map((row: IObject) => ({
      id: createUUID(),
      ...row,
    })) || [],
    name: backendType.name,
    datamodel_type: backendType.datamodel_type,
    datamodel_id: backendType.datamodel_id,
    created_at: backendType.created_at,
    report_id: backendType.report_id,
    query_filters: backendType.query_filters,
  };
  return result;
}
